import app from 'flarum/forum/app';
export function setAcceptedAnswer(discussionId, postId) {
  return app.request({
    method: 'POST',
    url: `${app.forum.attribute('apiUrl')}/devconnect/discussions/${discussionId}/accepted-answer`,
    body: {
      postId
    }
  });
}
export function toggleReaction(postId, reaction) {
  return app.request({
    method: 'POST',
    url: `${app.forum.attribute('apiUrl')}/devconnect/posts/${postId}/reaction`,
    body: {
      reaction
    }
  });
}
flarum.reg.add('devconnect-community', 'forum/service/communityApi', { setAcceptedAnswer: setAcceptedAnswer,toggleReaction: toggleReaction, });